<template>
  <div class="lines">
    <div class="line_ctn">
      <div class="line line1 blue" :class="pointClass">
        <Point v-if="point.ps1" :left="left" :value="currentValue" :unit="unit" />
        <div class="pos">水分饱和</div>
      </div>
      <div class="point point1" :class="pointClass">
        <span>{{ min }}</span>
        <Point v-if="point.ps2" :value="currentValue" :unit="unit" />
      </div>

      <div class="line line2 green" :class="pointClass">
        <Point v-if="point.ps3" :left="left" :value="currentValue" :unit="unit" />
        <div class="pos">适宜生长</div>
      </div>

      <div class="point point1" :class="pointClass">
        <span>{{ middle }}</span>
        <Point v-if="point.ps4" :value="currentValue" :unit="unit" />
      </div>

      <div class="line line4 yellow" :class="pointClass">
        <Point v-if="point.ps5" :left="left" :value="currentValue" :unit="unit" />
        <div class="pos">干旱</div>
      </div>

      <div class="point point2" :class="pointClass">
        <span>{{ max }}</span>
        <Point v-if="point.ps6" :value="currentValue" :unit="unit" />
      </div>

      <div class="line line3 red" :class="pointClass">
        <Point v-if="point.ps7" :left="left" :value="currentValue" :unit="unit" />
        <div class="pos">需要灌溉</div>
      </div>
    </div>
  </div>
</template>
<script>
import Point from "./Point";

export default {
  components: {
    Point
  },
  props: ['currentValue', 'min', 'middle', 'max', 'unit'],
  data () {
    return {
      left: 0,
      color: ["easy_blue", "easy_green", "easy_red", "easy_yellow"],
      pointClass: "",
      point: {
        ps1: true,
        ps2: false,
        ps3: false,
        ps4: false,
        ps5: false,
        ps6: false,
        ps6: false,
        ps7: false,
      },
    };
  },

  mounted () {

  },

  watch: {
    middle: {
      immediate: true,
      deep: true,
      handler (val) {
        this.renderRow()
      }
    }
  },

  methods: {
    renderRow () {
      console.log("????????????????????????????:", this.currentValue, this.min);
      const ganhan = this.middle

      this.currentValue = this.currentValue ? Number(this.currentValue) : 0

      // 四种情况  饱和  适宜  干旱  干旱要灌溉
      if (this.currentValue < this.min) {
        // 饱和
        this.pointClass = this.color[0];
        let left = (this.currentValue / this.min) * 100
        this.left = `${left}%`;
        this.renderPoint("ps1");
        console.log(11111, left);

      } else if (this.currentValue == this.min) {
        // 等于 刚好在交界点上
        this.pointClass = this.color[1];
        this.renderPoint("ps2");
        this.left = "0%%"

      } else if (this.currentValue > this.min && this.currentValue < ganhan) {
        // 适宜生长
        let left = (this.currentValue - this.min) / (ganhan - this.min) * 100
        this.left = `${left}%`;
        this.renderPoint("ps3");
        this.pointClass = this.color[1];
        console.log(33333, left);

      } else if (this.currentValue == ganhan) {
        // 适宜 干旱的交界点
        this.left = `${0}%`;
        this.renderPoint("ps4");
        this.pointClass = this.color[3];

      } else if (this.currentValue < this.max && this.currentValue > ganhan) {
        this.pointClass = this.color[3];
        let left = (this.currentValue - ganhan) / (this.max - ganhan) * 100
        this.left = `${left}%`;
        this.renderPoint("ps5");
        console.log(55555, left);

      } else if (this.currentValue == this.max) {
        this.left = `${0}%`;
        this.renderPoint("ps6");
        this.pointClass = this.color[2];
        console.log(66666, left);

      } else {
        this.pointClass = this.color[2];
        const bigMax = this.currentValue + 20
        console.log("bigMax: ", bigMax);
        let left = (this.currentValue - this.max) / (bigMax - this.max) * 100
        this.left = `${left}%`;
        this.renderPoint("ps7");
        console.log(7777, left);

      }
    },

    renderPoint (k) {
      Object.keys(this.point).map(key => {
        this.point[key] = false;
      });

      this.point[k] = true;
    }
  }
};
</script>

<style scoped lang="scss">
.lines {
  .line_ctn {
    display: flex;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .line {
      position: relative;
      width: 25%;
      height: 10px;
      border-radius: 8px;
    }
  }
}

.point {
  width: 0px;
  height: 0px;
  border-radius: 50%;
}

.point1,
.point2 {
  position: relative;

  span {
    position: absolute;
    bottom: -30px;
    left: -8px;
  }
}

.blue {
  background: rgba(87, 115, 255, 1);
}
.green {
  background: rgba(103, 194, 59, 1);
}
.red {
  background: rgba(243, 109, 108, 1);
}
.yellow {
  background: rgba(255, 170, 0, 1);
}

.pos {
  position: absolute;
  bottom: -25px;
  width: 100%;
  text-align: center;
}
</style>
